module.exports = __webpack_public_path__ + "media/images/front/societies/society_jsa_introduction-78dba0ed0546b256301c862cb2266e61.jpg";